import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import { Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowRight from "@mui/icons-material/ArrowRightAlt";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import LearningPathAssignmentsList from "./LearningPathAssignmentsList";
import { widgetKeys } from "../../../constants";
import { fetchUserAssignmentsList } from "../../../redux/actions/userAssignmentsListActions";
import { assignmentsSortMethods as sortByMethods } from "../../../constants";
import { useTranslation } from "react-i18next";
import LearningPathNoAssignmentsView from "../../../views/LearningPath/LearningPathNoAssignmentsView";
import { learnLearningPathListView } from "../../../routes/LearningCenterRoutes";
import UserAssignmentContext from "../../../context/UserAssignmentContext";

import { makeGetEntities } from "../../../redux/selectors/selectors";

const selector = makeGetEntities();

const linkToAssignmentsList = React.forwardRef((props, ref) => (
  <RouterLink innerRef={ref} to={learnLearningPathListView} {...props} />
));

const LearningPathListContainer = ({
  fetchUserAssignmentsList,
  assignments,
  dashboard,
  loading,
  isFetched
}) => {
  const { t } = useTranslation();
  const [sortByMethod, setSortByMethod] = useState(sortByMethods[0]);
  const { needsRefetch, setNeedsRefetch } = useContext(UserAssignmentContext);

  const loadAssignments = () => {
    fetchUserAssignmentsList({
      type: "admin_enrolled",
      order: sortByMethod.value,
      limit: 3
    });
  };

  useEffect(() => {
    loadAssignments();
  }, [sortByMethod]);

  useEffect(() => {
    if (needsRefetch) {
      loadAssignments();
      setNeedsRefetch(false);
    }
  }, [needsRefetch]);

  return (
    <DashboardWidgetContainer
      dashboard={dashboard}
      widgetDataLoading={loading}
      widgetKey={widgetKeys.myAssignments}
      title={t("learningPathAssignments.title")}
      dropdownProps={{
        value: sortByMethod,
        options: sortByMethods,
        onChange: setSortByMethod,
        label: t("sortBy")
      }}
    >
      <Box
        data-qa="dashboard-widgets-learning-path-list"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        flex={1}
      >
        {isFetched && (!assignments || assignments.length === 0) && (
          <LearningPathNoAssignmentsView showViewAllAssignmentsButton />
        )}
        {!loading && assignments && assignments.length > 0 && (
          <>
            <LearningPathAssignmentsList assignments={assignments} />
            <Box
              flex={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
              pt={3.75}
            >
              <Button
                variant="text"
                color="primary"
                component={linkToAssignmentsList}
                endIcon={<ArrowRight />}
              >
                {t("learningPathAssignments.viewAllMyAssignmentsButton")}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </DashboardWidgetContainer>
  );
};

const mapState = state => ({
  assignments: selector(state.userAssignmentsListState, {
    type: "userAssignment",
    id: state.userAssignmentsListState.displayedCourses.admin_enrolled
  }),
  error: state.userAssignmentsListState.error,
  loading: state.userAssignmentsListState.loading,
  isFetched: state.userAssignmentsListState.isFetched
});

export default connect(mapState, {
  fetchUserAssignmentsList
})(LearningPathListContainer);
